import React from 'react';
import {
  Flex,
  Box,
  Table,
  TableContainer,
  Thead,
  Tr,
  Th,
  Td,
  Tbody,
  Input,
} from '@chakra-ui/react';
import {AiFieldLabels, getFieldLabel} from '../../../../shared/fields/types';
import {pluralize} from '../../../../lib/helpers';
import {SectionContainer, SectionTitle} from './helpers';
import {useAgentBuilderServerState} from '../AgentBuilder.state';
import {useAgentFields} from '../helpers';
import {filterNull} from '../../../../shared/util';

export const FieldsSection = () => {
  const agentId = useAgentBuilderServerState().id;
  const {analystField, researcherField} = useAgentFields(agentId);
  const fields = filterNull([analystField, researcherField]);

  const numFields = fields.length;
  return (
    <SectionContainer>
      <SectionTitle>Fields</SectionTitle>
      <Flex direction="column" gap="3">
        <Box color="kgray.300">
          Each time the agent runs, it will enrich{' '}
          <Box as="span" color="kgray.500" fontWeight="500">
            {pluralize(numFields, 'field', 'fields')}
          </Box>
          :
        </Box>
        <TableContainer>
          <Table
            layout="fixed"
            sx={{
              'td, th': {
                padding: '8px',
                '&:first-of-type': {
                  paddingLeft: 0,
                  paddingRight: '20px',
                },
                '&:last-of-type': {
                  paddingLeft: '20px',
                  paddingRight: 0,
                },
              },
            }}
            variant="unstyled"
          >
            <colgroup>
              <col width="50%" />
              <col />
            </colgroup>
            <Thead>
              <Tr>
                <Th>Field Name</Th>
                <Th>Field Type</Th>
              </Tr>
            </Thead>
            <Tbody>
              {fields.map((field) => (
                <Tr key={field.id.toString()}>
                  <Td>
                    <Input value={getFieldLabel(field)} readOnly />
                  </Td>
                  <Td color="kgray.300">
                    {AiFieldLabels[field.config.fieldType]}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Flex>
    </SectionContainer>
  );
};
